import React, { useEffect } from "react";
import "./_text-module.scss"
import lozad from "lozad";

// import FileSaver from "file-saver"

// Functions
import { sanitize } from "§/src/utils/functions"

// Internal
import TileContentDownloads from "./tile-content-downloads"
import TileContentReports from "./tile-content-reports"
import TileContentWithImage from "./tile-content-with-image"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

// Utils
import UniversalLink from "§/src/utils/UniversalLink"

// Atoms
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"

// Language
import { useTranslation } from "react-i18next"

const TextModule = ({
  pretitle,
  title,
  content,
  cta,
  downloadstitle,
  downloadsfiles,
  orientation,
  reports,
  twotilesandimage,
  titleImage,
  titleMultiImage,
  template = '',
  positionInBundle = '',
  multiImage,
  ...props
}) => {
  const { t } = useTranslation()
  const atomClassName = "text-module"
  const atomClass =
    props?.className !== undefined
      ? atomClassName + " " + props?.className
      : atomClassName

  const downloadFile = async (fileUrl, fileName) => {
    // Verifica che siamo in un ambiente browser
    if (fileUrl && typeof document !== 'undefined') {
      try {
        let alink = document.createElement("a")
        alink.href = fileUrl
        alink.download = fileName || 'download'
        alink.target = "_blank"
        alink.click()

        // Pulizia per evitare memory leaks
        setTimeout(() => {
          alink = null;
        }, 100);
      } catch (error) {
        console.error('Download failed:', error);
      }
    }
  }

  useEffect(() => {
    // Verifica che siamo in un ambiente browser
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const { observe } = lozad('.wysywyg img', {
        load: function(el) {
          if (el && el.dataset && el.dataset.src) {
            el.src = el.dataset.src;
            el.onload = function() {
              el.classList.add('fade')
              el.classList.add('show')
            }
          }
        }
      })

      observe()
    }
  }, [])

  return (
    <div comp={atomClassName} className={atomClass + ' template-' + template + ' position-' + positionInBundle}>
      {orientation === "vertical" ? (
        <div className={"row flex-column gap-3 vertical"}>
          {pretitle && (
            <div className={"col-12"}>
              <p
                className="pretitle mb-2"
                dangerouslySetInnerHTML={{ __html: sanitize(pretitle || '') }}
              />
            </div>
          )}
          {title && (
            <div className="col col-12 col-md-12 col-lg-7 col-xl-5">
              <h3
                className="title mb-2 mb-lg-0"
                dangerouslySetInnerHTML={{ __html: sanitize(title || '') }}
              />
            </div>
          )}
          <div className={"right col col-md-12 col-lg-7 col-xl-5"}>
            <div className="d-flex flex-column gap-3 gap-md-5">
              {content && (
                <div
                  className="fs-16 content wysywyg"
                  dangerouslySetInnerHTML={{ __html: sanitize(content || '') }}
                />
              )}
              {twotilesandimage && (
                <TileContentWithImage
                  tiles={twotilesandimage?.tiles}
                  image={twotilesandimage?.image}
                />
              )}
              {downloadsfiles && (
                <TileContentDownloads
                  downloadstitle={downloadstitle}
                  downloadsfiles={downloadsfiles}
                  ondownload={downloadFile}
                />
              )}
            </div>
            {reports && <TileContentReports reports={reports} />}
          </div>
        </div>
      ) : (
        <div className={"row horizontal w-100"}>
          <div className={"col-12"}>
            {pretitle && (
              <p
                className="pretitle mb-2"
                dangerouslySetInnerHTML={{ __html: sanitize(pretitle || '') }}
              />
            )}
          </div>
          <div className="col-12 col-lg-4 col-xl-3">
            {title && (
              <h3
                className="title mb-2 mb-lg-0"
                dangerouslySetInnerHTML={{ __html: sanitize(title || '') }}
              />
            )}
            {titleImage && (
              <GatsbyImage
                className={`title-image mb-5 mt-lg-2`}
                image={getImage(titleImage)}
                objectFit={"contain"}
                alt={titleImage?.altText || 'title image'}
              />
            )}
            {titleMultiImage && Array.isArray(titleMultiImage) && titleMultiImage.length > 0 &&
              <div className="title-images d-flex mt-3">
                {titleMultiImage.map((elem, index) => {
                  const imageData = elem ? getImage(elem) : null;
                  if (!imageData) return null;
                  return (
                    <GatsbyImage
                      key={index}
                      className={`title-image mb-5`}
                      image={imageData}
                      objectFit={"contain"}
                      alt={elem?.altText || 'title image'}
                    />
                  );
                })}
              </div>
            }
          </div>
          <div className={"right col-md-12 col-lg-7 col-xl-5 offset-lg-1"}>
            <div className="d-flex flex-column gap-3 gap-md-5 position-relative">
              {content && (
                <div
                  className="fs-16 content wysywyg"
                  dangerouslySetInnerHTML={{ __html: sanitize(content || '') }}
                />
              )}
              {twotilesandimage && (
                <TileContentWithImage
                  tile1={null}
                  tile2={null}
                  image={twotilesandimage?.image}
                />
              )}
              {downloadsfiles && (
                <TileContentDownloads
                  downloadstitle={downloadstitle}
                  downloadsfiles={downloadsfiles}
                  ondownload={downloadFile}
                  className={props?.from === "news-template" ? "mt-5" : ""}
                />
              )}

              {cta && Array.isArray(cta) && (cta[1] || (cta[2] && cta[2] !== "0")) && (
                <UniversalLink to={cta} className="mt-auto">
                  <ButtonArrow
                    dir="end"
                    text={cta[2] || t("Approfondisci")}
                    className="text-primary cta stretched-link"
                  />
                </UniversalLink>
              )}
            </div>
            {reports && <TileContentReports reports={reports} />}
          </div>
        </div>
      )}
    </div>
  )
}

export default TextModule
